/**
 * Container Extended Handler
 * JavaScript for the container-extended widget features.
 * Handles editor preview style application and force repaints.
 */

class HoffmasterContainerExtendedHandler extends elementorModules.frontend.handlers.Base {
	getDefaultSettings() {
		return {
			selectors: {
				container: '.e-con',
			},
			classes: {
				bgLight1: 'hm-bg--light-1',
				bgLight2: 'hm-bg--light-2',
				bgDark1: 'hm-bg--dark-1',
				bgDark2: 'hm-bg--dark-2',
			},
		};
	}

	getDefaultElements() {
		// For container extensions, we work with this.$element directly
		// since it IS the container element
		return {
			$container: this.$element,
		};
	}

	bindEvents() {
		// Check if we're in Elementor editor context
		if (typeof elementorFrontend === 'undefined') {
			return; // Not in Elementor context
		}

		// Apply styles on initialization
		this.applyContainerStyles();
	}

	applyContainerStyles() {
		const classes = this.getSettings('classes');
		const $el = this.elements.$container;

		// Check if element has our custom classes and force style application
		if (
			$el.hasClass(classes.bgLight1) ||
			$el.hasClass(classes.bgLight2) ||
			$el.hasClass(classes.bgDark1) ||
			$el.hasClass(classes.bgDark2)
		) {
			// Force repaint to ensure CSS is applied
			// This is especially important in the editor preview
			$el[0].offsetHeight; // Trigger reflow
		}
	}
}

jQuery(window).on('elementor/frontend/init', () => {
	elementorFrontend.elementsHandler.attachHandler('container', HoffmasterContainerExtendedHandler);
});
